<div class="legend">
  <span class="legend__item"><span class="cell cell--ok"></span>{{ 'DATA_MONITORING_LEGEND_OK' | translate }}</span>
  <span class="legend__item"><span class="cell cell--warn">…</span>{{ 'DATA_MONITORING_LEGEND_WARN' | translate }}</span>
  <span class="legend__item"><span class="cell cell--problem">✕</span>{{ 'DATA_MONITORING_LEGEND_PROBLEM' | translate }}</span>
  <span class="legend__item"><span class="cell cell--none"></span>{{ 'DATA_MONITORING_LEGEND_NONE' | translate }}</span>
</div>

<section class="board">
  <div class="board__pager">
    <app-secondary-button
      icon="pi pi-chevron-left"
      [disable]="isFirstMonth()"
      [attr.aria-label]="'DATA_MONITORING_PREV_MONTH' | translate"
      (action)="previousMonth.emit()"
    ></app-secondary-button>
    <h3 class="board__month">{{ monthNameKey() | translate }} {{ year() }}</h3>
    <app-secondary-button
      icon="pi pi-chevron-right"
      [disable]="isLastMonth()"
      [attr.aria-label]="'DATA_MONITORING_NEXT_MONTH' | translate"
      (action)="nextMonth.emit()"
    ></app-secondary-button>
  </div>

  <div class="board__scroll">
    <table class="matrix">
      <thead>
        <tr>
          <th class="matrix__label"></th>
          @for (day of view().header; track day.iso) {
            <th class="matrix__day" [class.matrix__day--weekend]="day.weekend" [class.matrix__day--today]="day.today">
              <span class="matrix__day-number">{{ day.day }}</span>
              <span class="matrix__weekday">{{ day.weekdayKey | translate }}</span>
            </th>
          }
          <th class="matrix__total" [title]="'DATA_MONITORING_ROW_PROBLEMS' | translate">✕</th>
        </tr>
      </thead>
      <tbody>
        @for (group of view().groups; track group.key) {
          <tr class="matrix__group" (click)="toggleGroup.emit(group.key)">
            <th class="matrix__label" scope="row">
              <span class="matrix__toggle pi" [class.pi-chevron-right]="group.collapsed" [class.pi-chevron-down]="!group.collapsed"></span>
              {{ group.labelKey | translate }}
            </th>
            @for (cell of group.cells; track cell.iso) {
              <td><span class="cell cell--{{ cell.state }}">{{ cell.glyph }}</span></td>
            }
            <td class="matrix__total" [class.matrix__total--problem]="group.problems > 0">{{ group.problems || '' }}</td>
          </tr>
          @for (row of group.rows; track row.key) {
            <tr class="matrix__row" [class.matrix__row--highlighted]="row.highlighted" [attr.data-row-key]="row.key">
              <th class="matrix__label matrix__label--row" scope="row" [title]="row.label">{{ row.label }}</th>
              @for (cell of row.cells; track cell.iso) {
                <td>
                  <span class="cell cell--{{ cell.state }}" [attr.title]="cell.title" [attr.aria-label]="cell.title">{{ cell.glyph }}</span>
                </td>
              }
              <td class="matrix__total" [class.matrix__total--problem]="row.problems > 0">{{ row.problems || '' }}</td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  <details class="rules">
    <summary>{{ 'DATA_MONITORING_RULES_TITLE' | translate }}</summary>
    <ul>
      <li>{{ 'DATA_MONITORING_RULES_DAILY' | translate }}</li>
      <li>{{ 'DATA_MONITORING_RULES_FORECAST' | translate: { days: forecastDays(), horizon: forecastHorizon() } }}</li>
      <li>{{ 'DATA_MONITORING_RULES_NORM' | translate }}</li>
      <li>{{ 'DATA_MONITORING_RULES_YEARLY' | translate }}</li>
      <li>{{ 'DATA_MONITORING_RULES_SATELLITE_DOWNLOADED' | translate }}</li>
      <li>{{ 'DATA_MONITORING_RULES_SATELLITE' | translate }}</li>
      <li>{{ 'DATA_MONITORING_RULES_INDEX' | translate }}</li>
      <li>{{ 'DATA_MONITORING_RULES_ANOMALY' | translate }}</li>
    </ul>
  </details>
</section>
